import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useAuth } from '../../context/AuthContext';
import { Card, CardContent } from '../../components/ui/card';
import { MessageSquare } from 'lucide-react';
import { toast } from 'sonner';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ManageMessages() {
  const { token } = useAuth();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const headers = { Authorization: `Bearer ${token}` };

  useEffect(() => {
    const fetch = async () => {
      try {
        const res = await axios.get(`${API}/survey/responses`, { headers });
        setItems(res.data);
      } catch (e) { toast.error('Erreur'); }
      finally { setLoading(false); }
    };
    fetch();
  }, []);

  return (
    <div data-testid="manage-messages">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-[#1E3A5F]">Messages</h1>
        <p className="text-sm text-[#6B7C93]">{items.length} message(s)</p>
      </div>

      <div className="space-y-3">
        {items.map((item) => (
          <Card key={item.id} className="border-0 shadow-sm">
            <CardContent className="p-5">
              <p className="text-[#1E3A5F] mb-2">{item.feedback}</p>
              <div className="flex items-center gap-4 text-xs text-[#6B7C93]">
                {item.email && <span>{item.email}</span>}
                {item.rating && <span>Note: {item.rating}/5</span>}
                <span>{new Date(item.created_at).toLocaleDateString('fr-FR')}</span>
              </div>
            </CardContent>
          </Card>
        ))}
        {!loading && items.length === 0 && (
          <div className="text-center py-12 text-[#6B7C93]"><MessageSquare className="w-12 h-12 mx-auto mb-3 opacity-30" /><p>Aucun message</p></div>
        )}
      </div>
    </div>
  );
}
